import React, { useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useNavigate, Link } from "react-router-dom"; 
import Swal from "sweetalert2";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const AddSparePrecent = () => {
  const navigate = useNavigate(); 
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [formData, setFormData] = useState({
    fld_rate: "",
  });

   const canEntry = hasPermission("Hire vehicle Spare percentage", "entry");

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      Swal.fire({
                          title: "Submitting...",
                          text: "Please wait while we process your request.",
                          allowOutsideClick: false,
                          didOpen: () => {
                              Swal.showLoading();
                          },
                      });
      

      const response = await axios.post(`https://rfs2.infraconsoft.net.in/api/add_spare_percent_api/${selectedBranch}`,formData);
     Swal.fire("Success", "Spares Percentage Added Successfully", "success");
      
      // Reset the form after submission
      setFormData({ fld_rate: ""  });
 
      // Navigate to vehicle_sparspercentagemaster_listing after successful submission
      navigate("/vehicle_sparspercentagemaster_listing");

    } catch (error) {
      console.error("Error inserting details:", error);
      alert("Failed to insert record");
    }
  };


  if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                    <h2 className="add-txt">Vehicle Spare Percent Entry</h2>
                    <Link to='/vehicle_sparspercentagemaster_listing'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Spare Percent Entry date:</label>
<input
  type="text"
  value={new Date().toLocaleDateString("en-GB")} // d/m/y format
  readOnly
/>

              </div>
              <div className="form-group">
                <label>Spare Percent  :</label>
                <input
                  type="text"
                  name="fld_rate"
                  value={formData.fld_rate}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
        
      </div>
    </div>
  );
};

export default AddSparePrecent;
